import { MenuItem, Stack, TextField } from "@mui/material";
import { countryList, getStateProvinceOptions } from "../membership/clubLocations";
import { NewClub } from "./clubApi";

export const EMPTY_CLUB: NewClub = { name: "", country: "", state: "", city: "" };

export function isClubComplete(club: NewClub) {
  return !!(club.name.trim() && club.country && club.state.trim() && club.city.trim());
}

function ClubRegistrationFields({
  club,
  onChange,
  autoFocus = false,
}: {
  club: NewClub;
  onChange: (club: NewClub) => void;
  autoFocus?: boolean;
}) {
  const stateOptions = getStateProvinceOptions(club.country);
  return (
    <Stack spacing={2}>
      <TextField
        inputProps={{ "data-testid": "club-name" }}
        label="Club Name"
        value={club.name}
        onChange={(event) => onChange({ ...club, name: event.target.value })}
        autoFocus={autoFocus}
      />
      <TextField
        inputProps={{ "data-testid": "club-country" }}
        label="Country"
        value={club.country}
        onChange={(event) =>
          onChange({ ...club, country: event.target.value, state: "" })
        }
        select
      >
        {countryList.map((country) => (
          <MenuItem key={country.code} value={country.code}>
            {country.name}
          </MenuItem>
        ))}
      </TextField>
      {stateOptions.length > 0 ? (
        <TextField
          inputProps={{ "data-testid": "club-state" }}
          label="State/Province/Region"
          value={club.state}
          onChange={(event) => onChange({ ...club, state: event.target.value })}
          select
        >
          {stateOptions.map((state) => (
            <MenuItem key={state} value={state}>
              {state}
            </MenuItem>
          ))}
        </TextField>
      ) : (
        <TextField
          inputProps={{ "data-testid": "club-state" }}
          label="State/Province/Region"
          value={club.state}
          onChange={(event) => onChange({ ...club, state: event.target.value })}
          disabled={!club.country}
          placeholder={!club.country ? "Select a country first" : ""}
        />
      )}
      <TextField
        inputProps={{ "data-testid": "club-city" }}
        label="City"
        value={club.city}
        onChange={(event) => onChange({ ...club, city: event.target.value })}
      />
    </Stack>
  );
}

export default ClubRegistrationFields;
